module.exports = __webpack_public_path__ + "img/scan_tip.ae65b8ed.png";